import { createReducer } from '@reduxjs/toolkit';
import {
  PASSKEY_REGISTRATION_OPTIONS_REQUEST,
  PASSKEY_REGISTRATION_OPTIONS_SUCCESS,
  PASSKEY_REGISTRATION_OPTIONS_ERROR,
  PASSKEY_REGISTER_REQUEST,
  PASSKEY_REGISTER_SUCCESS,
  PASSKEY_REGISTER_ERROR,
  PASSKEY_AUTHENTICATION_OPTIONS_REQUEST,
  PASSKEY_AUTHENTICATION_OPTIONS_SUCCESS,
  PASSKEY_AUTHENTICATION_OPTIONS_ERROR,
  PASSKEY_AUTHENTICATE_REQUEST,
  PASSKEY_AUTHENTICATE_SUCCESS,
  PASSKEY_AUTHENTICATE_ERROR,
  PASSKEY_LIST_REQUEST,
  PASSKEY_LIST_SUCCESS,
  PASSKEY_LIST_ERROR,
  PASSKEY_DELETE_REQUEST,
  PASSKEY_DELETE_SUCCESS,
  PASSKEY_DELETE_ERROR,
  PASSKEY_RENAME_REQUEST,
  PASSKEY_RENAME_SUCCESS,
  PASSKEY_RENAME_ERROR,
  CLEAR_PASSKEY_ERROR,
} from './PasskeyActions';

const initialState = {
  isLoading: false,
  error: null,
  registrationOptions: null,
  authenticationOptions: null,
  passkeys: [],
  lastRegistration: null,
  lastAuthentication: null,
};

const passkeyReducer = createReducer(initialState, {
  // Registration options
  [PASSKEY_REGISTRATION_OPTIONS_REQUEST]: state => ({
    ...state,
    isLoading: true,
    error: null,
  }),
  [PASSKEY_REGISTRATION_OPTIONS_SUCCESS]: (state, action) => ({
    ...state,
    isLoading: false,
    registrationOptions: action.payload,
    error: null,
  }),
  [PASSKEY_REGISTRATION_OPTIONS_ERROR]: (state, action) => ({
    ...state,
    isLoading: false,
    error: action.payload,
  }),

  // Registration
  [PASSKEY_REGISTER_REQUEST]: state => ({
    ...state,
    isLoading: true,
    error: null,
  }),
  [PASSKEY_REGISTER_SUCCESS]: (state, action) => ({
    ...state,
    isLoading: false,
    lastRegistration: action.payload,
    error: null,
    registrationOptions: null, // Clear options after successful registration
  }),
  [PASSKEY_REGISTER_ERROR]: (state, action) => ({
    ...state,
    isLoading: false,
    error: action.payload,
  }),

  // Authentication options
  [PASSKEY_AUTHENTICATION_OPTIONS_REQUEST]: state => ({
    ...state,
    isLoading: true,
    error: null,
  }),
  [PASSKEY_AUTHENTICATION_OPTIONS_SUCCESS]: (state, action) => ({
    ...state,
    isLoading: false,
    authenticationOptions: action.payload,
    error: null,
  }),
  [PASSKEY_AUTHENTICATION_OPTIONS_ERROR]: (state, action) => ({
    ...state,
    isLoading: false,
    error: action.payload,
  }),

  // Authentication
  [PASSKEY_AUTHENTICATE_REQUEST]: state => ({
    ...state,
    isLoading: true,
    error: null,
  }),
  [PASSKEY_AUTHENTICATE_SUCCESS]: (state, action) => ({
    ...state,
    isLoading: false,
    lastAuthentication: action.payload,
    error: null,
    authenticationOptions: null, // Clear options after successful authentication
  }),
  [PASSKEY_AUTHENTICATE_ERROR]: (state, action) => ({
    ...state,
    isLoading: false,
    error: action.payload,
  }),

  // List passkeys
  [PASSKEY_LIST_REQUEST]: state => ({
    ...state,
    isLoading: true,
    error: null,
  }),
  [PASSKEY_LIST_SUCCESS]: (state, action) => ({
    ...state,
    isLoading: false,
    passkeys: action.payload,
    error: null,
  }),
  [PASSKEY_LIST_ERROR]: (state, action) => ({
    ...state,
    isLoading: false,
    error: action.payload,
  }),

  // Delete passkey
  [PASSKEY_DELETE_REQUEST]: state => ({
    ...state,
    isLoading: true,
    error: null,
  }),
  [PASSKEY_DELETE_SUCCESS]: (state, action) => ({
    ...state,
    isLoading: false,
    passkeys: state.passkeys.filter(p => p.id !== action.payload),
    error: null,
  }),
  [PASSKEY_DELETE_ERROR]: (state, action) => ({
    ...state,
    isLoading: false,
    error: action.payload,
  }),

  // Rename passkey
  [PASSKEY_RENAME_REQUEST]: state => ({
    ...state,
    isLoading: true,
    error: null,
  }),
  [PASSKEY_RENAME_SUCCESS]: (state, action) => ({
    ...state,
    isLoading: false,
    passkeys: state.passkeys.map(p =>
      p.id === action.payload.passkeyId ? { ...p, name: action.payload.name } : p,
    ),
    error: null,
  }),
  [PASSKEY_RENAME_ERROR]: (state, action) => ({
    ...state,
    isLoading: false,
    error: action.payload,
  }),

  // Clear error
  [CLEAR_PASSKEY_ERROR]: state => ({
    ...state,
    error: null,
  }),
});

export default passkeyReducer;
